module.exports = __webpack_public_path__ + "static/media/Food-4.eaf8459b.png";